import { api } from "./api"

export const GET_ALL_THEMES = async (
    { page = 0, siglas, withInteractions, authors, entities, ...others } : 
    { 
        page?: number;
        siglas?: string[];
        withInteractions?: boolean;
        authors?: string[];
        entities?: string[];
        [key: string]: any;
    } = {}
) => {
    const {data} = await api.get("/themes", { params: { page, siglas, withInteractions, authors, entities, ...others } })
    return data.themes || [];
}

export const GET_FILTERS_OPTIONS = async () => {
    const {data} = await api.get("/themes/filters/options")
    return data;
}

export const GET_ALL_SIGLAS = async () => {
    const {data} = await api.get("/themes/siglas/all")
    return data.siglas || [];
}

export const GET_ALL_ENTITIES = async () => {
    const {data} = await api.get("/themes/entities/all")
    return data.entities || [];
}

export const GET_ALL_AUTHORS = async () => {
    const {data} = await api.get("/themes/authors/all")
    return data.authors || [];
}

export const GET_THEME = async (id : string) => {
    const {data} = await api.get(`/themes/${id}`)
    return data.theme || null;
}

export const GET_THEME_COMMENTS = async (id : string) => {
    const {data} = await api.get(`/themes/${id}/comments`)
    return data.comments || null;
}

export const GET_THEME_INSIGHTS = async (id : string, type: string) => {
    const {data} = await api.get(`/themes/${id}/insights/${type}`)
    return data;
}

export const SAVE_THEME_ADDITIONAL_DATA = async (id : string, {type, data}) => {
    await api.patch(`/themes/${id}/others`, {type, data})
}

export const DELETE_THEME = async (id) => {
    const {data} = await api.delete(`/themes/${id}`)
    return data;
}

export const CREATE_THEME = async (params : any) => {
    const {data} = await api.post(`/themes`, params)
    return data;
}

export const FOLLOW_THEME = async (id : string, follow : boolean) => {
    const {data} = await api.patch(`/themes/${id}/follow`, {follow})
    return data;
}

export const INTERACT_THEME = async (id : string, params : {favorable?: string, priority?: string}) => {
    const {data} = await api.patch(`/themes/${id}/interact`, params)
    return data;
}

export const COMMENT_THEME = async (id : string, params : {comment?: string, destin?: string}) => {
    const {data} = await api.post(`/themes/${id}/comment`, params)
    return data;
}

export const CHANGE_THEME_ATTRIBUTE = async (themeId: number, attributeId : number, value: any, type : string) => {
    const formData = new FormData();
    if(['file', 'image'].includes(type)){
        value.forEach((v, i) => { formData.append(`files`, v) });
    }else{
        formData.append("value", value);
    }
    const {data} = await api.patch(`/themes/${themeId}/attribute/${attributeId}`, formData, {
        headers: { "content-type": "multipart/form-data", },
    });
    return data;
}



